import React, { useState } from "react";
import img1 from "../img/CRM.png";
import img2 from "../img/logo.png";
import img3 from "../img/b8848521dfcad7a98f4457cf21288315.jpg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNewLoginMutation } from "../redux/api/Login";
import { loginSuccess } from "../redux/reducer/reducer";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [input, setInput] = useState({
    phone: "",
    password: "",
  });
  const [phoneError, setPhoneError] = useState("");
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const [postLogin] = useNewLoginMutation();

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (input.phone === "") {
      setPhoneError("Please enter your Phone number");
      setTimeout(() => {
        setPhoneError("");
      }, 2000);
      return;
    } else if (input.password === "") {
      setPhoneError("Please enter your Password");
      setTimeout(() => {
        setPhoneError("");
      }, 2000);
      return;
    } else {
      const postData = {
        mobile: input.phone,
        password: input.password,
      };
      postLogin(postData)
        .then((response) => {
          if (response.data.status === 200) {
            // console.log("Success", response);
            dispatch(loginSuccess(response?.data));
            localStorage.setItem("userData", JSON.stringify(response?.data));
            localStorage.setItem("userToken", response?.data?.token);
            naviagte("/");
          } else {
            setPhoneError("Invalid Credential");
            setTimeout(() => {
              setPhoneError("");
            }, 3000);
          }
        })
        .catch((error) => {
          setPhoneError("Invalid Credential");
          setTimeout(() => {
            setPhoneError("");
          }, 3000);
        });
    }
  };

  const handleShow = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="d-none  d-lg-flex d-xl-flex  d-md-flex  login-section">
        <div className="w-50  banner">
          <img src={img1} className="img-fluid" id="child" alt="" />
        </div>
        <div className="w-50 position-relative " id="half-bg-img">
          <div className="d-flex justify-content-center mt-5 mb-3" id="logo">
            <img src={img2} className="img-fluid" alt="" />
          </div>
          <div className="text-center text-white" id="Right-form-text">
            <h2 className="display-6" id="form-heading">
              Propcasa sales CRM
            </h2>
            <p>Symbol of Excellence</p>
            <h2 className="mt-5 title position-relative" id="login-heading">
              Log in now
            </h2>
            <p className="text-white"> {phoneError}</p>
            <div className="form-outer mt-4">
              <div className="container">
                <form className="form" onSubmit={handleLogin}>
                  <div
                    className="mb-2 form-input w-100 d-flex align-items-center  bg-white position-relative rounded-3 px-2"
                    id="form-input"
                  >
                    <span className="icon">
                      <i className="bi bi-phone"></i>
                    </span>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      className="w-100 py-2 rounded-3 border-0 ps-4"
                      placeholder="Phone Number"
                      value={input.phone}
                      onChange={handleChange}
                      maxLength={10}
                    />
                  </div>
                  <div
                    className="mb-2 form-input w-100 d-flex align-items-center  bg-white position-relative rounded-3 px-2"
                    id="form-input"
                  >
                    <span className="icon">
                      <i className="me-1 fa-solid fa-lock text-danger"></i>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      placeholder="Password"
                      className="w-100 py-2 rounded-3 border-0 ps-4"
                      value={input.password}
                      onChange={handleChange}
                    />
                    <span onClick={handleShow}>
                      <i className="bi bi-eye-fill  pe-4 text-danger "></i>
                    </span>
                  </div>

                  <div className="d-grid gap-2 col-12 mx-auto">
                    <button
                      className="btn py-2"
                      type="submit"
                      id="button-custom"
                    >
                      Login
                    </button>
                  </div>

                  <p
                    className="mt-5 position-absolute bottom-0 start-50 translate-middle-x  "
                    id="form-privacy "
                  >
                    By continuing, you agree to our Terms of Service, Privacy
                    Policy, Content Policy
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-block  d-lg-none d-xl-none  d-md-none login-section position-relative ">
        <img src={img3} alt="" className="w-100 h-100 " />
        <div className="mbile-view-login position-absolute top-0 start-0  h-100 w-100">
          <div className="pt-4">
            <div className="d-flex justify-content-center mt-5 mb-3" id="logo">
              <img src={img2} className="img-fluid" alt="" />
            </div>
            <div className="text-center text-white" id="Right-form-text">
              <h2 className="display-6" id="form-heading">
                Propcasa sales CRM
              </h2>
              <p>Symbol of Excellence</p>
              <h2
                className="mt-4 title position-relative mt-5"
                id="login-heading"
              >
                Log in now
              </h2>
              <p className="text-white"> {phoneError}</p>
              <form className="form-outer mt-4" onSubmit={handleLogin}>
                <div className="container">
                  <div className="form">
                    <div
                      className="mb-3 form-input w-100 d-flex align-items-center  bg-white position-relative rounded-3 px-2"
                      id="form-input"
                    >
                      <span className="icon">
                        <i className="bi bi-phone"></i>
                      </span>
                      <input
                        type="text"
                        name="phone"
                        id="phone"
                        className="w-100 py-2 rounded-3 border-0 ps-4"
                        placeholder="Phone Number"
                        value={input.phone}
                        onChange={handleChange}
                        maxLength={10}
                      />
                    </div>
                    <div
                      className="mb-3 form-input w-100 d-flex align-items-center  bg-white position-relative rounded-3 px-2"
                      id="form-input"
                    >
                      <span className="icon">
                        <i className="me-1 fa-solid fa-lock text-danger"></i>
                      </span>
                      <input
                       type={showPassword ? "text" : "password"}
                        name="password"
                        id="password"
                        placeholder="Password"
                        className="w-100 py-2 rounded-3 border-0 ps-4"
                        value={input.password}
                        onChange={handleChange}
                      />
                      <span onClick={handleShow}>
                      <i className="bi bi-eye-fill  pe-4 text-danger "></i>
                    </span>
                    </div>

                    <div className="d-grid gap-2 col-12 mx-auto">
                      <button
                        className="btn py-2"
                        type="submit"
                        id="button-custom"
                      >
                        Login
                      </button>
                    </div>

                    <p className=" position-absolute bottom-0 start-0 ">
                      By continuing, you agree to our Terms of Service, Privacy
                      Policy, Content Policy
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
